import { isEmpty, isNull } from 'lodash';
import React, { useEffect } from 'react';
import { useAuthorizedDSPs } from '../hooks/useLps/useAuthorizedDSPs';
import { useAuthorizedEntities } from '../hooks/useLps/useAuthorizedEntities';
import { useAuthorizedLps } from '../hooks/useLps/useAuthorizedLps';
import { useLpSelected } from '../hooks/useLps/useLpSelected';

const CLWSAuthZCaller = ({ authorizationDispatch }) => {
  const {
    dispatchGetAuthorizedEntities,
    dispatchGetAuthorizedLps,
    dispatchGetLPDetails,
    dispatchGetAuthorizedDSPs,
  } = authorizationDispatch;
  const authorizedEntities = useAuthorizedEntities();
  const lpSelected = useLpSelected();
  const authorizedLps = useAuthorizedLps();
  const authorizedDSPs = useAuthorizedDSPs();
  useEffect(() => {
    if (isEmpty(authorizedEntities)) return;
    dispatchGetAuthorizedEntities(authorizedEntities);
  }, [authorizedEntities]);

  useEffect(() => {
    if (isEmpty(lpSelected)) return;
    dispatchGetLPDetails(lpSelected);
  }, [lpSelected]);

  useEffect(() => {
    if (isNull(authorizedLps)) return;
    dispatchGetAuthorizedLps(authorizedLps);
  }, [authorizedLps]);

  useEffect(() => {
    if (isNull(authorizedDSPs)) return;
    dispatchGetAuthorizedDSPs(authorizedDSPs);
  }, [authorizedLps]);

  return <></>;
};

export default CLWSAuthZCaller;
